export const styles = {
  card: {
    border: '1px solid #E5E7EB',
    borderRadius: 18,
    padding: 18,
    background: '#FFFFFF',
    boxShadow: '0 6px 18px rgba(15, 23, 42, 0.04)',
    marginBottom: 16,
  },
  header: {
    display: 'flex',
    justifyContent: 'space-between',
    gap: 12,
    alignItems: 'center',
    marginBottom: 14,
  },
  titleWrap: {
    display: 'flex',
    gap: 12,
    minWidth: 0,
    flex: 1,
    alignItems: 'flex-start',
  },
  iconBox: {
    width: 28,
    height: 28,
    borderRadius: 8,
    background: '#F3F4F6',
    border: '1px solid #E5E7EB',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    color: '#6B7280',
    flexShrink: 0,
  },
  titleRow: {
    display: 'flex',
    gap: 10,
    alignItems: 'center',
    flexWrap: 'wrap',
    marginBottom: 2,
  },
  title: {
    fontSize: 14,
    lineHeight: '20px',
    fontWeight: 700,
    color: '#111827',
  },
  desc: {
    fontSize: 12,
    lineHeight: '18px',
    color: '#6B7280',
  },
  createdBy: {
    fontSize: 12,
    lineHeight: '18px',
    color: '#374151',
    marginBottom: 2,
  },
  createdByLabel: {
    fontWeight: 700,
    color: '#111827',
  },
  statusPill: isActive => ({
    display: 'inline-flex',
    alignItems: 'center',
    justifyContent: 'center',
    height: 28,
    padding: '0 10px',
    borderRadius: 999,
    border: `1px solid ${isActive ? '#86EFAC' : '#D1D5DB'}`,
    background: isActive ? '#ECFDF5' : '#F9FAFB',
    color: isActive ? '#059669' : '#6B7280',
    fontSize: 12,
    fontWeight: 700,
  }),
  infoGrid: {
    display: 'grid',
    gridTemplateColumns: 'repeat(auto-fit, minmax(200px, 1fr))',
    gap: 10,
    marginBottom: 10,
  },
  infoCard: {
    borderRadius: 12,
    background: '#F9FAFB',
    padding: '12px 14px',
    border: '1px solid #E5E7EB',
    minHeight: 72,
  },
  infoLabel: {
    display: 'flex',
    alignItems: 'center',
    gap: 8,
    fontSize: 12,
    color: '#6B7280',
    marginBottom: 8,
  },
  infoValue: {
    fontSize: 13,
    lineHeight: '18px',
    fontWeight: 700,
    color: '#111827',
  },
  infoValueWarn: {
    fontSize: 13,
    lineHeight: '18px',
    fontWeight: 700,
    color: '#D97706',
  },
  linkRow: {
    display: 'flex',
    alignItems: 'center',
    gap: 10,
    marginBottom: 12,
  },
  linkInput: {
    flex: 1,
    height: 42,
    borderRadius: 12,
    border: '1px solid #E5E7EB',
    background: '#FFFFFF',
    padding: '0 14px',
    fontSize: 12,
    color: '#6B7280',
  },
  copyBtn: {
    width: 40,
    height: 40,
    borderRadius: 12,
    border: '1px solid #D1D5DB',
    background: '#FFFFFF',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    color: '#4B5563',
    cursor: 'pointer',
    flexShrink: 0,
  },
  footer: {
    display: 'flex',
    justifyContent: 'flex-end',
    gap: 12,
    alignItems: 'center',
    flexWrap: 'wrap',
  },
  chip: {
    display: 'inline-flex',
    alignItems: 'center',
    gap: 8,
    minHeight: 32,
    padding: '0 12px',
    borderRadius: 12,
    background: '#F3F4F6',
    color: '#374151',
    fontSize: 13,
    fontWeight: 600,
  },
  menuWrap: {
    position: 'relative',
    flexShrink: 0,
  },
  menuBtn: {
    width: 32,
    height: 32,
    borderRadius: 10,
    border: 'none',
    background: 'transparent',
    color: '#6B7280',
    cursor: 'pointer',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
  },
  menu: {
    position: 'absolute',
    top: 42,
    right: 0,
    minWidth: 220,
    padding: 8,
    borderRadius: 16,
    background: '#FFFFFF',
    border: '1px solid #E5E7EB',
    boxShadow: '0 16px 40px rgba(15, 23, 42, 0.15)',
    zIndex: 10,
  },
  menuItem: {
    width: '100%',
    height: 40,
    display: 'flex',
    alignItems: 'center',
    gap: 10,
    padding: '0 10px',
    border: 'none',
    background: 'transparent',
    borderRadius: 10,
    fontSize: 14,
    color: '#374151',
    cursor: 'pointer',
  },
  menuItemDanger: {
    width: '100%',
    height: 40,
    display: 'flex',
    alignItems: 'center',
    gap: 10,
    padding: '0 10px',
    border: 'none',
    background: 'transparent',
    borderRadius: 10,
    fontSize: 14,
    color: '#DC2626',
    cursor: 'pointer',
  },
};
